import styled from 'styled-components'

export const Container = styled.div`
  margin-top: -120px;
  display: flex;
  flex-direction: column;
  width: 100vw;
  z-index: 150;
  margin-bottom: 90px;
  @media (max-width: 768px) {
    margin-top: -80px;
  }
  @media (max-width: 425px) {
    margin-top: 0;
  }
  .grid {
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 96vw;
    margin: auto;
    .general, .official {
      width: 210px;
      height: 210px;
      @media (max-width: 768px) {
        width: 195px;
        height: 195px;
      }
      @media (max-width: 510px) {
        width: 140px;
        height: 140px;
      }
    }
    .title, .consul, .media {
      width: 160px;
      height: 160px;
      @media (max-width: 768px) {
        width: 132px;
        height: 132px;
      }
      @media (max-width: 510px) {
        width: 80px;
        height: 80px;
      }
    }
    .partners, .info {
      width: 110px;
      height: 110px;
      @media (max-width: 768px) {
        width: 75px;
        height: 75px;
      }
      @media (max-width: 510px) {
        width: 55px;
        height: 55px;
      }
    }
  }
`

export const Partner = styled.div`
  text-decoration: none;
  border-radius: 6px;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.07);
  position: relative;
  width: 150px;
  height: 150px;
  overflow: hidden;
  margin: 10px;
  padding: 20px;
  background-color: #fff;
  @media (max-width: 768px) {
    margin: 8px;
    padding: 15px;
  }
  @media (max-width: 510px) {
    padding: 10px;
  }
  &:hover {
    .logo {
      transform: scale(1.1);
    }
  }
`

export const Logo = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #000;
  background: url(${({ logo }) => logo}) no-repeat center center;
  background-size: contain;
  margin-bottom: 10px;
  transition-duration: 0.2s;
`

export const Section = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px 0;
  .name {
    font-family: StolzlMedium, serif;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 2px;
    text-align: center;
    color: #000;
    margin: 0 30px;
  }
`

export const Line = styled.div`
  background-color: #d2dae4;
  height: 1px;
  width: 100%;
  flex: 1;
`
